import { gql } from '@apollo/client';

export const UPDATE_PICKUP_TASK_STATUS = gql`
  mutation UpdatePickupTaskStatus($taskId: String!, $status: PickupTaskStatus!, $warehouseId: Long!) {
    updateTaskStatus(taskId: $taskId, status: $status, warehouseId: $warehouseId) {
      id
      status
    }
  }
`; 